"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MessageTypes = void 0;

var react_1 = __importDefault(require("react"));

var handleEvent_1 = require("../assets/handleEvent");

var withResponsive_1 = require("../decorators/withResponsive");

var withStyles_1 = require("../decorators/withStyles");

var Popup_1 = __importDefault(require("../Popup/Popup"));

var FramePopup_styles_1 = require("./FramePopup.styles");

var MessageTypes;

(function (MessageTypes) {
  MessageTypes["CLOSE"] = "CLOSE";
  MessageTypes["SET_HEIGHT"] = "SET_HEIGHT";
  MessageTypes["SET_WIDTH"] = "SET_WIDTH";
})(MessageTypes = exports.MessageTypes || (exports.MessageTypes = {}));

var FramePopup =
/** @class */
function (_super) {
  __extends(FramePopup, _super);

  function FramePopup(props) {
    var _this = _super.call(this, props) || this;

    var initialWidth = props.initialWidth,
        initialHeight = props.initialHeight,
        src = props.src;
    _this.onMessageHandler = _this.onMessageHandler.bind(_this);
    _this.origin = _this.getOrigin(src);
    _this.state = {
      width: initialWidth,
      height: initialHeight
    };
    return _this;
  }

  FramePopup.prototype.componentDidMount = function () {
    window.addEventListener('message', this.onMessageHandler);
  };

  FramePopup.prototype.componentWillUnmount = function () {
    window.removeEventListener('message', this.onMessageHandler);
  };

  FramePopup.prototype.getOrigin = function (src) {
    var source;

    if (!src.includes(':')) {
      source = window.location;
    } else {
      var a = document.createElement('A');
      a.href = src;
      source = a;
    }

    var origin = source.origin,
        protocol = source.protocol,
        hostname = source.hostname;
    return origin || protocol + "//" + hostname;
  };

  FramePopup.prototype.onMessageHandler = function (event) {
    var _a = this.props,
        onHide = _a.onHide,
        onMessage = _a.onMessage;

    if (event.origin !== this.origin && event.origin !== window.location.origin) {
      return;
    }

    var data = event.data;

    if (data) {
      var message = void 0;

      try {
        message = JSON.parse(data);
      } catch (error) {
        return;
      }

      switch (message.type) {
        case MessageTypes.SET_HEIGHT:
          {
            var height = message.height;
            this.sizeChangeProcess({
              height: height
            });
            break;
          }

        case MessageTypes.SET_WIDTH:
          {
            var width = message.width;
            this.sizeChangeProcess({
              width: width
            });
            break;
          }

        case MessageTypes.CLOSE:
          handleEvent_1.handleEvent(onHide);
          break;
      }

      handleEvent_1.handleEvent(onMessage, event);
    }
  };

  FramePopup.prototype.sizeChangeProcess = function (newSize) {
    var onSizeChange = this.props.onSizeChange;
    handleEvent_1.handleEvent(onSizeChange, newSize);
    var newState = Object.keys(newSize).reduce(function (state, key) {
      var _a;

      if (!newSize[key] && typeof newSize[key] !== 'number') {
        return state;
      }

      return __assign(__assign({}, state), (_a = {}, _a[key] = newSize[key], _a));
    }, {});
    this.setState(newState);
  };

  FramePopup.prototype.render = function () {
    var _a = this.props,
        show = _a.show,
        container = _a.container,
        onShow = _a.onShow,
        onHide = _a.onHide,
        backdrop = _a.backdrop,
        onEscapeKeyUp = _a.onEscapeKeyUp,
        onBackdropClick = _a.onBackdropClick,
        closeByEsc = _a.closeByEsc,
        autoFocus = _a.autoFocus,
        enforceFocus = _a.enforceFocus,
        restoreFocus = _a.restoreFocus,
        manager = _a.manager,
        closeByBackdropClick = _a.closeByBackdropClick,
        responsive = _a.responsive,
        src = _a.src,
        classes = _a.classes,
        allowFullScreen = _a.allowFullScreen,
        iframeScrolling = _a.iframeScrolling,
        propsWidth = _a.width,
        propsHeight = _a.height,
        testId = _a.testId;
    var _b = this.state,
        width = _b.width,
        height = _b.height;
    return react_1.default.createElement(Popup_1.default, {
      testId: testId,
      show: show,
      container: container,
      onShow: onShow,
      onHide: onHide,
      backdrop: backdrop,
      onEscapeKeyUp: onEscapeKeyUp,
      onBackdropClick: onBackdropClick,
      closeByEsc: closeByEsc,
      autoFocus: autoFocus,
      enforceFocus: enforceFocus,
      restoreFocus: restoreFocus,
      manager: manager,
      width: propsWidth || width,
      height: propsHeight || height,
      closeByBackdropClick: closeByBackdropClick,
      responsive: responsive
    }, react_1.default.createElement("div", {
      className: classes.wrapper,
      style: {
        width: propsWidth || width,
        height: propsHeight || height
      }
    }, react_1.default.createElement("iframe", {
      "data-test-id": "frame-popup-iframe",
      src: src,
      className: classes.iframe,
      frameBorder: 0,
      scrolling: iframeScrolling || 'auto',
      allowFullScreen: allowFullScreen
    })));
  };

  FramePopup = __decorate([withResponsive_1.withResponsive, withStyles_1.withStyles(FramePopup_styles_1.styles)], FramePopup);
  return FramePopup;
}(react_1.default.Component);

exports.default = FramePopup;